module.exports = function (key) {
  switch (key) {
    case 'tool.library.video': return 'tool.library.videos';
    case 'popupmenu.tooltip.text_align_left': return 'popupmenu.tooltip.align_left';
    case 'popupmenu.tooltip.text_align_right': return 'popupmenu.tooltip.align_right';
    case 'popupmenu.tooltip.background_opacity': return 'popupmenu.tooltip.opacity';

    case 'tool.restrictions.template.permission.icon_deletion': return 'editor.delete';
    case 'tool.restrictions.template.permission.image_deletion': return 'editor.delete';
    case 'tool.restrictions.template.permission.logo_deletion': return 'editor.delete';
    case 'tool.restrictions.template.permission.text_deletion': return 'editor.delete';
    case 'tool.restrictions.template.permission.vector_deletion': return 'editor.delete';
    case 'tool.restrictions.template.permission.video_deletion': return 'editor.delete';

    case 'tool.restrictions.template.permission.icon_position': return 'editor.move';
    case 'tool.restrictions.template.permission.image_position': return 'editor.move';
    case 'tool.restrictions.template.permission.logo_position': return 'editor.move';
    case 'tool.restrictions.template.permission.text_position': return 'editor.move';
    case 'tool.restrictions.template.permission.vector_position': return 'editor.move';
    case 'tool.restrictions.template.permission.video_position': return 'editor.move';

    case 'tool.restrictions.template.permission.image_duplication': return 'editor.duplicate';
    case 'tool.restrictions.template.permission.logo_duplication': return 'editor.duplicate';
    case 'tool.restrictions.template.permission.text_duplication': return 'editor.duplicate';
    case 'tool.restrictions.template.permission.vector_duplication': return 'editor.duplicate';
    case 'tool.restrictions.template.permission.icon_duplication': return 'editor.duplicate';
    case 'tool.restrictions.template.permission.video_duplication': return 'editor.duplicate';

    case 'tool.restrictions.template.permission.icon_opacity': return 'tool.restrictions.template.permission.common.opacity';
    case 'tool.restrictions.template.permission.image_opacity': return 'tool.restrictions.template.permission.common.opacity';
    case 'tool.restrictions.template.permission.logo_opacity': return 'tool.restrictions.template.permission.common.opacity';
    case 'tool.restrictions.template.permission.text_opacity': return 'tool.restrictions.template.permission.common.opacity';
    case 'tool.restrictions.template.permission.vector_opacity': return 'tool.restrictions.template.permission.common.opacity';

    case 'tool.restrictions.template.permission.icon_rotation': return 'tool.restrictions.template.permission.common.rotate';
    case 'tool.restrictions.template.permission.video_rotation': return 'tool.restrictions.template.permission.common.rotate';
    case 'tool.restrictions.template.permission.image_rotation': return 'tool.restrictions.template.permission.common.rotate';
    case 'tool.restrictions.template.permission.logo_rotation': return 'tool.restrictions.template.permission.common.rotate';
    case 'tool.restrictions.template.permission.text_rotation': return 'tool.restrictions.template.permission.common.rotate';
    case 'tool.restrictions.template.permission.vector_rotation': return 'tool.restrictions.template.permission.common.rotate';

    case 'tool.restrictions.template.permission.icon_size': return 'tool.restrictions.template.permission.common.size';
    case 'tool.restrictions.template.permission.logo_size': return 'tool.restrictions.template.permission.common.size';
    case 'tool.restrictions.template.permission.vector_size': return 'tool.restrictions.template.permission.common.size';
    case 'tool.restrictions.template.permission.video_size': return 'tool.restrictions.template.permission.common.size';

    case 'tool.restrictions.template.permission.icon_stroke': return 'tool.restrictions.template.permission.common.stroke';
    case 'tool.restrictions.template.permission.logo_stroke': return 'tool.restrictions.template.permission.common.stroke';

    case 'tool.restrictions.template.permission.icon_colour': return 'tool.restrictions.template.permission.common.colour';
    case 'tool.restrictions.template.permission.text_colour': return 'tool.restrictions.template.permission.common.colour';
    case 'tool.restrictions.template.permission.vector_colour': return 'tool.restrictions.template.permission.common.colour';

    case 'tool.restrictions.template.permission.image_content': return 'tool.restrictions.template.permission.image_replace';

    case 'tool.restrictions.template.permission.function_download_file': return 'editor.download_file';
    case 'tool.restrictions.template.permission.logo_colour': return 'tool.restrictions.template.permission.common.fill_colour';

    case 'tool.restricted.add.image_add': return 'editor.images';
    case 'tool.restricted.add.logo_add': return 'editor.logos';
    case 'tool.restricted.do.function_download_file': return 'editor.download_file';

    case 'shapes.names.basic.circle': return 'editor.circle';
    case 'shapes.names.basic.ellipse': return 'editor.ellipse';
    case 'shapes.names.basic.line': return 'editor.line';
    case 'shapes.names.basic.rectangle': return 'editor.rectangle';
    case 'shapes.names.basic.square': return 'editor.square';
    case 'shapes.names.web.raph_download': return 'general.download';
    case 'shapes.names.web.raph_flickr': return 'social.flickr';
    case 'shapes.names.web.raph_home': return 'general.home';
    case 'shapes.names.web.raph_linkedin': return 'social.linkedin';
    case 'shapes.names.web.raph_pen': return 'editor.pen';
    case 'shapes.names.web.raph_search': return 'general.search';
    case 'shapes.names.web.raph_settings': return 'general.settings';
    case 'shapes.names.web.raph_tag': return 'social.tag';
    case 'shapes.names.web.raph_twitter': return 'social.twitter';
    case 'shapes.names.web.raph_undo': return 'editor.undo';
    case 'shapes.names.web.raph_unlock': return 'editor.unlock';
    case 'shapes.names.web.raph_view': return 'editor.view';
  }

  return key;
};
